import { useCallback } from "react"
import { Button, ButtonProps, useMultiStyleConfig } from "@chakra-ui/react"

type TokenAmountInputMaxButtonProps = ButtonProps & {
  /**
   * Maximum value that can be set for input. In token (user) unit.
   */
  maxTokenAmount: string
  setTokenAmount: (amount: string) => void
}

export default function TokenAmountInputMaxButton({
  maxTokenAmount,
  setTokenAmount,
  children,
  variant,
  size,
  isDisabled,
  ...props
}: TokenAmountInputMaxButtonProps) {
  const styles = useMultiStyleConfig("TokenAmountInput", { variant, size })

  const maxButtonClickHandler = useCallback(() => {
    setTokenAmount(maxTokenAmount)
  }, [setTokenAmount, maxTokenAmount])

  return (
    <Button
      onClick={maxButtonClickHandler}
      isDisabled={maxTokenAmount === "0" || isDisabled}
      {...(styles.maxButton as ButtonProps)}
      {...props}
    >
      {children}
    </Button>
  )
}
